import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/program/activity')({
  loader: () => i18n.loadNamespaces('program/activity'),
})
